import { Box, Grid, Typography } from "@mui/material";
import { StyledEstablecimientos } from "../../../../styled/Prevencion";

const HeaderLabelPresentacion = ({ presentacion }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <StyledEstablecimientos.PaperOutlined elevation={2}>
          <StyledEstablecimientos.HeaderDiv>
            <Box sx={{ display: "flex", paddingLeft: "20px" }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#000" }}>
                {`SVCC Res. 81/19 - Presentación: ${presentacion?.numeroPresentacion ?? presentacion?.nroPresentacion ?? ""} Muestra: ${presentacion?.numeroMuestra ?? presentacion?.nroMuestra ?? ""}`}
              </Typography>
            </Box>
          </StyledEstablecimientos.HeaderDiv>
        </StyledEstablecimientos.PaperOutlined>
      </Grid>
    </Grid>
  );
};

export default HeaderLabelPresentacion;
